import { render, staticRenderFns } from "./ImportSubjects.vue?vue&type=template&id=7e9f9228&scoped=true&"
import script from "@/views/Curricula/ImportSubjects.ts?vue&type=script&lang=ts&"
export * from "@/views/Curricula/ImportSubjects.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Curricula/import-subjects.scss?vue&type=style&index=0&id=7e9f9228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9f9228",
  null
  
)

export default component.exports